const apiUrl = 'https://api.creatorcart.com'; // 'https://creators.creatorcart.com/api';

async function handleResponse<T>(res: Response): Promise<T> {
  const parsedResponse = await res.json();
  if (res.ok) return parsedResponse;
  throw new Error(parsedResponse.message, { cause: parsedResponse });
}

async function request<T>(url: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(`${apiUrl}/${url}`, options);
  return handleResponse(response);
}

interface FetchService {
  [key: string]: <T>(url: string, payload?: unknown) => Promise<T>;
}

const headers = {
  'Content-Type': 'application/json',
};

export const fetchService: FetchService = {
  get: (url) =>
    request(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        ...headers,
        Accept: 'application/json',
      },
    }),
  post: (url, payload = {}) => {
    const body = JSON.stringify(payload);
    return request(url, {
      method: 'POST',
      headers,
      body,
    });
  },
  patch: (url, payload = {}) => {
    const body = JSON.stringify(payload);
    return request(url, {
      method: 'PATCH',
      headers,
      body,
    });
  },
};
